import axios from "axios";

const getDefaultState = () => {
  return {
    allOrders: [],
    allOrdersLoading: false,
    fields: {
      ALL_SYNATEC_ORDERS: `
        id
        created_at
        status
        agent {
          full_name
        }
        customer {
          id
          company_name
        }
        order {
          id
          order_no
        }
        notes
        _rowVariant
      `
    }
  };
};

const state = getDefaultState();

const getters = {
  getAllOrders(state) {
    return state.allOrders;
  },
  getAllOrdersLoading(state) {
    return state.allOrdersLoading;
  }
};

const actions = {
  fetchOrdersPagination({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            orders: SynatecOrdersPagination (
              ${ payload.status != null ? `status: "${payload.status}",` : ''}
              limit: ${payload.limit},
              offset: ${payload.offset},
              order: "${payload.order}"
            ) { ${state.fields.ALL_SYNATEC_ORDERS} }
          }
        `
      }
    };

    dispatch("fetchCommitOrders", commitPayload);
  },
  /*
  fetchOrdersLikeAgent({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            orders: OrdersLikeAgentName(
              agent_name: "${payload.agentName}",
              ${ payload.status != null ? `status: "${payload.status}",` : ''}
              limit: ${payload.limit},
              offset: ${payload.offset},
            ) {
              ${state.fields.ALL_SYNATEC_ORDERS}
            }
          }
        `
      }
    };

    dispatch("fetchCommitOrders", commitPayload);
  },
  */
  fetchOrdersLikeCustomer({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            orders: SynatecOrdersLikeCustomerName(
              customer_name: "${payload.customerName}",
              ${ payload.status != null ? `status: "${payload.status}",` : ''}
              limit: ${payload.limit},
              offset: ${payload.offset},
            ) {
              ${state.fields.ALL_SYNATEC_ORDERS}
            }
          }
        `
      }
    };

    dispatch("fetchCommitOrders", commitPayload);
  },
  fetchCommitOrders({ state, commit, rootGetters, dispatch }, payload) {
    return new Promise((resolve) => {
      commit("setAllOrdersLoading", true);

      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              // Check for timeout error to logout
              if (e.message == "Login timeout, logout and login again.") {
                dispatch("auth/logOut", null, { root: true });
                resolve(false);
              }

              dispatch("axios_mod/makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              }, { root: true });
            });
            resolve(false);
          } else {
            commit('setAllOrders', res.data.data.orders);
            resolve();
          }
        })
        .catch(err => {
          dispatch("axios_mod/makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          }, { root: true });
          resolve(false);
        })
        .finally(()=>{ commit("setAllOrdersLoading", false) });
    });
  },
};

const mutations = {
  setAllOrders(state, value) {
    state.allOrders = value;
  },
  setAllOrdersLoading(state, value) {
    state.allOrdersLoading = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
